import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-project-activity-types',
  templateUrl: './project-activity-types.component.html',
  styleUrls: ['./project-activity-types.component.css']
})
export class ProjectActivityTypesComponent implements OnInit {
    projectKeyno;

    public setting?: Setting;

    public itemsListProjectActivityTypes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.projectKeyno = this.stateService.getStateParams()['project_keyno'];
    }

    private async loadSetting() {
        if (!!this.projectKeyno) {
            this.setting = (await this.datatask.Post(2183, { project_keyno: this.projectKeyno }))[0];
        }
    }

    private async loadProjectActivityTypes() {
        if (!this.setting) return;

        return this.itemsListProjectActivityTypes = await this.datatask.Post(2184, { project_keyno: this.setting.project_keyno });
    }

    private async init() {
        await this.loadSetting();
        this.loadProjectActivityTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    webpage_heading: string;
    project_keyno: string;
}
